function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2477 0.5H4.74924C2.67859 0.5 1 2.17893 1 4.25V11.75C1 13.8211 2.67859 15.5 4.74924 15.5H12.2477C14.3184 15.5 15.9969 13.8211 15.9969 11.75V4.25C15.9969 2.17893 14.3184 0.5 12.2477 0.5Z",
  stroke: "#CECECE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4976 7.52751C11.5901 8.1517 11.4835 8.78918 11.193 9.34928C10.9024 9.90938 10.4427 10.3636 9.87913 10.6473C9.31561 10.931 8.677 11.0297 8.05413 10.9295C7.43126 10.8292 6.85585 10.5351 6.40975 10.0889C5.96365 9.64269 5.66957 9.06717 5.56935 8.44417C5.46912 7.82118 5.56785 7.18243 5.85148 6.61879C6.13512 6.05515 6.58923 5.59532 7.14921 5.30469C7.7092 5.01407 8.34654 4.90745 8.9706 5.00001C9.60716 5.09443 10.1965 5.39111 10.6515 5.84624C11.1066 6.30138 11.4032 6.89082 11.4976 7.52751Z",
  stroke: "#CECECE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.623 3.87502H12.632",
  stroke: "#CECECE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLogoInstagram = function SvgLogoInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_instagram.f4295aaa.svg";
export { ForwardRef as ReactComponent };